import React, { useContext } from 'react'
import { I18nextContext } from '@toasttab/shared/src/context/i18nextContext'
import { localizeLink } from '@toasttab/shared/src/utils/linkUtils'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import { ImageLinkProps } from './ImageLink.d'

const ImageLink = ({
  ctaLink,
  image,
  imageAlt,
  newWindow,
  classes
}: ImageLinkProps) => {
  const context = useContext(I18nextContext)
  const linkHref = localizeLink(ctaLink, context.language, context)

  return (
    <a
      className={classes}
      data-testid='ImageLink'
      href={linkHref}
      rel='noreferrer'
      target={newWindow ? '_blank' : '_self'}
    >
      <Image
        imageAlt={imageAlt || image?.title}
        objectCover={false}
        url={image?.file?.url}
      />
    </a>
  )
}

export default ImageLink
